module.exports = __webpack_public_path__ + "static/img/btn_06.c36f21e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/header/btn_06.png
// module id = BBtW
// module chunks = 4